<section class="header-img-wrapper">
    <div class="container-full-img">

        <picture>
            <source media="(min-width: 992px)" srcset="/assets/img/home/lokales.jpg">
            <source media="(min-width: 480px)" srcset="/assets/img/home/seebensee.jpg">
            <source media="(min-width: 0px)" srcset="assets/img/home/seebensee.jpg">
            <img class="img-responsive" src="/assets/img/home/seebensee.jpg"
                 alt="Alexander Koenig">
        </picture>
    </div>
    <article class="container-full">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-sm-8 col-md-6">
                    <div class="container-full-content">
                        <h2 class="headline-special">Fotografie<span>- Lokales</span>
                        </h2>
                        <p>Schon immer wollte ich die Geschichten hinter den perfekten Momenten festhalten.<br/>Vor
                            einigen Jahren, bin ich dann verstärkt auf die Fotografie gekommen um den perfekten Moment
                            fotografisch festzuhalten...</p>
                    </div>
                </div>
            </div>
        </div>
    </article>
</section>
<section id="wrapper" class="container content-wrapper detail">

    <article class="row">
        <div class="col-xs-12">
            <h1 class="headline">Fotografie - Lokales</h1>
        </div>
    </article>


    <div class="gallery">
        <div class="image"><img class="lazy-image loaded" src="./assets/img/architektur/thumb/U5B6620.jpg"></div>
        <div class="image"><img class="lazy-image loaded" src="./assets/img/architektur/thumb/U5B6693.jpg"></div>
        <div class="image image--big"><img class="lazy-image loaded" src="./assets/img/architektur/thumb/U5B6620.jpg">
        </div>
        <div class="image"><img class="lazy-image loaded" src="./assets/img/event/thumb/IMG_2053.jpg"></div>
        <div class="image image--big"><img class="lazy-image loaded" src="/assets/img/event/thumb/IMG_2060.jpg"></div>
        <div class="image"><img class="lazy-image loaded" src="/assets/img/event/thumb/IMG_9912.jpg"></div>
        <div class="image"><img class="lazy-image loaded" src="/assets/img/lanscape/thumb/ammersee.jpg"></div>
        <div class="image image--horizontal"><img class="lazy-image loaded"
                                                  src="/assets/img/lanscape/thumb/GOPR8792.jpg"></div>
        <div class="image"><img class="lazy-image loaded" src="/assets/img/lanscape/thumb/IMG_5375_starnberger_see.jpg">
        </div>
        <div class="image image--horizontal"><img class="lazy-image loaded"
                                                  src="/assets/img/lanscape/thumb/IMG_2757.jpg"></div>
        <div class="image"><img class="lazy-image loaded" src="/assets/img/lanscape/thumb/IMG_8071.jpg"></div>
        <div class="image"><img class="lazy-image loaded" src="/assets/img/lanscape/thumb/seebensee.jpg"></div>
        <div class="image"><img class="lazy-image loaded" src="/assets/img/politik/thumb/IMG_1406.jpg"></div>
        <div class="image image--horizontal"><img class="lazy-image loaded"
                                                  src="/assets/img/politik/thumb/IMG_2025.jpg"></div>
        <div class="image"><img class="lazy-image loaded" src="/assets/img/sport/thumb/IMG_3199.jpg"></div>
        <div class="image image--big"><img class="lazy-image loaded" src="/assets/img/sport/thumb/IMG_9252.jpg"></div>
        <div class="image"><img class="lazy-image loaded" src="/assets/img/sport/thumb/IMG_8762.jpg"></div>
        <div class="image image--vertical"><img class="lazy-image loaded" src="/assets/img/sport/thumb/IMG_8949.jpg">
        </div>
        <div class="image"><img src="/assets/img/sport/thumb/IMG_9252.jpg"></div>
        <div class="image"><img src="/assets/img/staedte/beirut/thumb/Beirut.jpg"></div>
        <div class="image image--vertical"><img src="/assets/img/staedte/beirut/thumb/IMG_3307.jpg"></div>
        <div class="image image--big"><img src="/assets/img/staedte/muenchen/thumb/IMG_5209.jpg"></div>
        <div class="image image--big"><img src="/assets/img/staedte/santorini/thumb/santorini.jpg"></div>
        <div class="image"><img src="/assets/img/staedte/muenchen/thumb/muenchen.jpg"></div>
        <div class="image image--vertical"><img src="/assets/img/staedte/muenchen/thumb/IMG_7879.jpg"></div>
        <div class="image"><img src="/assets/img/staedte/muenchen/thumb/oktoberfest.jpg"></div>
        <div class="image"><img src="/assets/img/event/thumb/IMG_2588.jpg"></div>
        <div class="image"><img src="https://source.unsplash.com/random/676"></div>
        <div class="image"><img src="https://source.unsplash.com/random/667"></div>
        <div class="image"><img src="https://source.unsplash.com/random/652"></div>
        <div class="image image--big"><img src="https://source.unsplash.com/random/667"></div>
        <div class="image"><img src="https://source.unsplash.com/random/646"></div>
        <div class="image"><img src="https://source.unsplash.com/random/667"></div>
        <div class="image"><img src="https://source.unsplash.com/random/653"></div>
        <div class="image image--horizontal"><img src="https://source.unsplash.com/random/632"></div>
    </div>
</section>
